import {
  SET_ONBOARD_STEP,
  CREATE_CUSTOMER,
  CREATE_CUSTOMER_SUCCESS,
  CREATE_CUSTOMER_FAILURE,
  UPLOAD_DOCUMENT,
  UPLOAD_DOCUMENT_SUCCESS,
  UPLOAD_DOCUMENT_FAILURE,
  UPDATE_PERIOD_INFO,
  UPDATE_PERIOD_INFO_SUCCESS,
  UPDATE_PERIOD_INFO_FAILURE,
  SET_PERMISSIONS,
  SET_PERMISSIONS_SUCCESS,
  SET_PERMISSIONS_FAILURE,
  SET_ALLOWANCE,
  SET_ALLOWANCE_SUCCESS,
  SET_ALLOWANCE_FAILURE,
  ONBOARD_EMPLOYEE,
  ONBOARD_EMPLOYEE_SUCCESS,
  ONBOARD_EMPLOYEE_FAILURE,
  SET_ONBOARDING_DATA,
  UPDATE_BASIC_INFO,
  UPDATE_BASIC_INFO_SUCCESS,
  UPDATE_BASIC_INFO_FAILURE,
  SET_ONBOARD_INFO,
  GET_DOCUMENTS,
  GET_DOCUMENTS_SUCCESS,
  GET_DOCUMENTS_FAILURE,
  SET_FILE_LIST,
  SET_ACCOUNTING_TYPE,
  UPLOAD_COMMON_DOCUMENT,
  UPLOAD_COMMON_DOCUMENT_SUCCESS,
  UPLOAD_COMMON_DOCUMENT_FAILURE,
  GET_COMMON_DOCUMENTS,
  GET_COMMON_DOCUMENTS_SUCCESS,
  GET_COMMON_DOCUMENTS_FAILURE,
  DOWNLOAD_DOC,
  DOWNLOAD_DOC_SUCCESS,
  DOWNLOAD_DOC_FAILURE,
} from "./constants";

// List
export const setOnboardStep = (payload) => ({
  type: SET_ONBOARD_STEP,
  payload,
});

export const uploadDocument = (payload, callback) => ({
  type: UPLOAD_DOCUMENT,
  payload,
  callback,
});

export const uploadDocumentSuccess = (payload) => ({
  type: UPLOAD_DOCUMENT_SUCCESS,
  payload,
});

export const uploadDocumentFailure = (payload) => ({
  type: UPLOAD_DOCUMENT_FAILURE,
  payload,
});

export const createCustomer = (payload, callback) => ({
  type: CREATE_CUSTOMER,
  payload,
  callback,
});

export const createCustomerSuccess = (payload) => ({
  type: CREATE_CUSTOMER_SUCCESS,
  payload,
});

export const createCustomerFailure = (payload) => ({
  type: CREATE_CUSTOMER_FAILURE,
  payload,
});

export const updatePeriodInfo = (payload, callback) => ({
  type: UPDATE_PERIOD_INFO,
  payload,
  callback,
});

export const updatePeriodInfoSuccess = (payload) => ({
  type: UPDATE_PERIOD_INFO_SUCCESS,
  payload,
});

export const updatePeriodInfoFailure = (payload) => ({
  type: UPDATE_PERIOD_INFO_FAILURE,
  payload,
});

export const setPermissions = (payload, callback) => ({
  type: SET_PERMISSIONS,
  payload,
  callback,
});
export const setPermissionsSuccess = (payload) => ({
  type: SET_PERMISSIONS_SUCCESS,
  payload,
});
export const setPermissionsFailure = (payload) => ({
  type: SET_PERMISSIONS_FAILURE,
  payload,
});

export const setAllowance = (payload) => ({
  type: SET_ALLOWANCE,
  payload,
});
export const setAllowanceSuccess = (payload) => ({
  type: SET_ALLOWANCE_SUCCESS,
  payload,
});
export const setAllowanceFailure = (payload) => ({
  type: SET_ALLOWANCE_FAILURE,
  payload,
});

export const onboardEmployee = (payload, callback) => ({
  type: ONBOARD_EMPLOYEE,
  payload,
  callback,
});

export const onboardEmployeeSuccess = (payload) => ({
  type: ONBOARD_EMPLOYEE_SUCCESS,
  payload,
});
export const onboardEmployeeFailure = (payload) => ({
  type: ONBOARD_EMPLOYEE_FAILURE,
  payload,
});
export const setOnboardingData = (payload) => ({
  type: SET_ONBOARDING_DATA,
  payload,
});

export const updateBasicInfo = (payload, callback) => ({
  type: UPDATE_BASIC_INFO,
  payload,
  callback,
});
export const updateBasicInfoSuccess = (payload) => ({
  type: UPDATE_BASIC_INFO_SUCCESS,
  payload,
});
export const updateBasicInfoFailure = (payload) => ({
  type: UPDATE_BASIC_INFO_FAILURE,
  payload,
});

export const setOnboardingInfo = (payload) => ({
  type: SET_ONBOARD_INFO,
  payload,
});

export const getDocuments = (payload) => ({
  type: GET_DOCUMENTS,
  payload,
});

export const getDocumentsSuccess = (payload) => ({
  type: GET_DOCUMENTS_SUCCESS,
  payload,
});

export const getDocumentsFailure = (payload) => ({
  type: GET_DOCUMENTS_FAILURE,
  payload,
});

export const setFileList = (payload) => ({
  type: SET_FILE_LIST,
  payload,
});

export const setAccountingType = (payload) => ({
  type: SET_ACCOUNTING_TYPE,
  payload,
});

export const uploadCommonDocument = (payload, callback) => ({
  type: UPLOAD_COMMON_DOCUMENT,
  payload,
  callback,
});

export const uploadCommonDocumentSuccess = (payload) => ({
  type: UPLOAD_COMMON_DOCUMENT_SUCCESS,
  payload,
});

export const uploadCommonDocumentFailure = (payload) => ({
  type: UPLOAD_COMMON_DOCUMENT_FAILURE,
  payload,
});

export const getCommonDocuments = (payload, callback) => ({
  type: GET_COMMON_DOCUMENTS,
  payload,
  callback,
});

export const getCommonDocumentsSuccess = (payload) => ({
  type: GET_COMMON_DOCUMENTS_SUCCESS,
  payload,
});

export const getCommonDocumentsFailure = (payload) => ({
  type: GET_COMMON_DOCUMENTS_FAILURE,
  payload,
});

export const downloadDoc = (payload, callback) => ({
  type: DOWNLOAD_DOC,
  payload,
  callback,
});

export const downloadDocSuccess = (payload) => ({
  type: DOWNLOAD_DOC_SUCCESS,
  payload,
});

export const downloadDocFailure = (payload) => ({
  type: DOWNLOAD_DOC_FAILURE,
  payload,
});
